import { render } from "./IconMore.vue?vue&type=template&id=272b1cf4&scoped=true"
import script from "./IconMore.vue?vue&type=script&lang=js"
export * from "./IconMore.vue?vue&type=script&lang=js"

import "./IconMore.vue?vue&type=style&index=0&id=272b1cf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272b1cf4"]])

export default __exports__